// チェックインは当日の日付をデフォルトにする
// flatpickr標準のキーワード "today" が使える
var datepickerConfig1 = {
  dateFormat: "Y/m/d",
  defaultDate: "today",
  minDate: "today",
  locale: "ja",
  disableMobile: true,
  // チェックイン日を変更した際に、チェックアウト日をチェックイン日の翌日に変更する。
  // 同時に、チェックイン日を含む前の日付を選択できないようにする。
  // カレンダーのインスタンスはページ内に複数あるため、indexを指定する必要あり。
  // また、予約サイトの設定上、選択できるのは最大15泊までとする。
  onChange: function onChange(selectedDates, dateStr, instance) {
    var dateObj = new Date(selectedDates);
    var newCheckOutDate = dateObj.setDate(dateObj.getDate() + 1);
    var maxCheckOutDate = dateObj.setDate(dateObj.getDate() + 14);
    var index = fp1.indexOf(instance);
    fp2[index].set("minDate", newCheckOutDate);
    fp2[index].set("maxDate", maxCheckOutDate);
    fp2[index].setDate(newCheckOutDate);
  }
};

// チェックアウトは翌日の日付をデフォルトにする
// 予約サイトの設定上、選択できるのは最大15泊までとする
var date = new Date();
var tommorow = date.setDate(date.getDate() + 1);
var maxDate = date.setDate(date.getDate() + 14);
var datepickerConfig2 = {
  dateFormat: "Y/m/d",
  defaultDate: tommorow,
  minDate: tommorow,
  maxDate: maxDate,
  locale: "ja",
  disableMobile: true
};

// レストラン予約日
// フォーマットがチェックイン/アウトとは異なることに注意
var datepickerConfig3 = {
  dateFormat: "Y-m-d",
  defaultDate: "today",
  minDate: "today",
  locale: "ja",
  disableMobile: true
};

// 宿泊予約用カレンダー（チェックイン日・チェックアウト日）
var fp1 = flatpickr("#datepicker1", datepickerConfig1);
var fp2 = flatpickr("#datepicker2", datepickerConfig2);

// レストラン予約用カレンダー
var fp3 = flatpickr("#datepicker3", datepickerConfig3);